import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  effects as profileEffects,
  selectors as profileSelectors,
} from 'lib/entities/profile';

import auth from 'utils/auth';

function useProfileData() {
  // get data from reducer
  const dispatch = useDispatch();

  // get data from profile
  const { data: dataProfile } = useSelector(profileSelectors);

  useEffect(() => {
    // check if profile data is available
    const parsedCookie = auth.getToken();
    if (parsedCookie) {
      const {
        accessToken: { token },
      } = parsedCookie;

      // check if there's token but empty data profile
      if (token && !dataProfile.id) {
        const userAccess = auth.getUserAccess();

        // @ts-ignore
        const { username } = userAccess;

        // get user data profile
        // @ts-ignore
        dispatch(profileEffects.getUserProfile(username));
      }
    }
  }, [dispatch, dataProfile]);
}

export default useProfileData;
